import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FlightCarriersComponent from './FlightCarriersComponent';
import { getFlightCarriersIcons } from './utils/getFlightCarriersIcons';

const FlightCarriers = () => {
  const websiteId = useSelector((state) => state.settings.value.websiteId);
  const [flightCarriers, setFlightCarriers] = useState([]);

  useEffect(() => {
    setFlightCarriers(getFlightCarriersIcons(websiteId));
  }, [websiteId]);

  return <FlightCarriersComponent flightCarriers={flightCarriers} />;
};

export default FlightCarriers;
